// extracted by mini-css-extract-plugin
module.exports = {"AboutPage":"about_AboutPage__2stTd","Astronaut":"about_Astronaut__1sxsA"};